<template>
	<div>Contact
		<iframe frameborder="0" style="height:1000px;width:99%;border:none;" src='https://forms.zohopublic.eu/distributionautomobilesdisco/form/Formulairecontactsiteweb/formperma/oEueTpFrqCLI1m-dWbcFwq8shgkPBhgByIUtwVv2mzs'></iframe>
	</div>
</template>

<script>
export default {
	name: 'Contact',
	data () {
		return {}
	}
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Contact.vue